export default __webpack_public_path__ + "static/media/medal.ed447681.png";